import {
    Col, Divider, PageHeader, Row, Space, Typography,
} from 'antd';
import { BiHash } from 'react-icons/bi';
import { MdOutlineNoPhotography } from 'react-icons/md';

import { ReactNode, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { PROOF_OF_DELIVERY_TYPE } from '../../const/pod.constants';

import { IBooking } from '../../interfaces/booking.interface';

interface ProofOfDeliveryTypeProps {
  [key: string]: {
    keyName: string;
    icon: ReactNode;
    message: string;
  }
}

const { Text, Title } = Typography;

const ProofOfDelivery = ({
    bookingData,
}: {
    bookingData: IBooking;
}) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });

    // const [avatarModal, setAvatarModal] = useState<boolean>(false);

    // const openAvatarModal = () => setAvatarModal(true);
    // const closeAvatarModal = () => setAvatarModal(false);

    const requireProof = bookingData?.requiresProofOfDelivery;
    const isProofPhotoType = bookingData?.proofOfDeliveryType === PROOF_OF_DELIVERY_TYPE.PHOTO;
    const isProofCodeType = bookingData?.proofOfDeliveryType === PROOF_OF_DELIVERY_TYPE.CODE;

    const NO_PROOF_TYPES: ProofOfDeliveryTypeProps = {
        [PROOF_OF_DELIVERY_TYPE.PHOTO]: {
            keyName: PROOF_OF_DELIVERY_TYPE.PHOTO,
            icon: <MdOutlineNoPhotography size={20} style={{ verticalAlign: 'middle' }} />,
            message: t('NO_PROOF_OF_DELIVERY_PHOTO'),
        },
        [PROOF_OF_DELIVERY_TYPE.CODE]: {
            keyName: PROOF_OF_DELIVERY_TYPE.CODE,
            icon: <BiHash size={20} style={{ verticalAlign: 'middle' }} />,
            message: t('NO_PROOF_OF_DELIVERY_CODE'),
        },
    };

    const noProofOfDelivery = (noProof: any) => (
        <Space direction="horizontal" size={8}>
            {noProof.icon}
            <Text>
                {noProof.message}
            </Text>
        </Space>
    );

    // const RequirePhotoProof = () => (
    //     bookingData.proofOfDelivery ? (
    //         <AvatarDeliveryProof
    //             proofOfDelivery={bookingData.proofOfDelivery}
    //             expandPhoto={() => openAvatarModal()}
    //         />
    //     ) : noProofOfDelivery(NO_PROOF_TYPES.PHOTO)
    // );

    const RequireCodeProof = () => (
        bookingData?.proofValidationCode ? (
            <Title level={4} style={{ textAlign: 'center' }}>
                {`# ${bookingData.proofValidationCode}`}
            </Title>
        ) : noProofOfDelivery(NO_PROOF_TYPES.CODE)
    );

    return (
        <Row justify="space-between" align="top" gutter={[24, 32]}>
            <Col xs={24} lg={12}>
                <Space direction="vertical" size={12}>
                    <PageHeader
                        title={(
                            <Title level={5} style={{ marginBottom: 0 }}>
                                {t('PROOF_OF_DELIVERY')}
                            </Title>
                        )}
                        footer={<Divider />}
                    />
                    {/* <AvatarModal
                        visible={avatarModal}
                        proofOfDelivery={bookingData.proofOfDelivery}
                        onCancel={() => closeAvatarModal()}
                    /> */}
                    <div>
                        {
                            requireProof
                                ? isProofPhotoType
                                    ? null
                                    : isProofCodeType && <RequireCodeProof />
                                : (
                                    <Text>
                                        { t('NO_REQUIRE_DELIVERY_PROOF') }
                                    </Text>
                                )
                        }
                    </div>
                </Space>
            </Col>
            <Col xs={24} lg={12}>
                {/* <Certification booking={bookingData} /> */}
            </Col>
        </Row>
    );
};

export default memo(ProofOfDelivery);
